<template>
    <div id="app" v-bind:style="scale">
        <router-view></router-view>
    </div>
</template>
<style scoped>
    #app {
        width: 1920px;
        transform-origin: top left;
        overflow-x: hidden;
    }
</style>
<script>
    import VueRouter from 'vue-router'

    export default {
        name: 'App',
        components: {},
        watch: {
            '$route' (to) {
                if (to.meta && to.meta.title) {
                    document.title = to.meta.title;
                }
            }
        },
        data() {
            return {
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight
            }
        },
        computed: {
            scale: function() {
                let t = this.windowWidth / 1920;
                let h = this.windowHeight / t;
                return `transform: scale(${t}); -ms-transform:scale(${t});-moz-transform:scale(${t});-webkit-transform:scale(${t});-o-transform:scale(${t}); height: ${h}px`
            }
        },
        mounted() {
            let that = this;
            this.$nextTick(function() {
                window.addEventListener('resize', function(e) {
                    that.windowWidth = window.innerWidth;
                    that.windowHeight = window.innerHeight;
                });
            })
        }
    }
</script>

<style>
    #app {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
    }

    button {
        outline: none;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue